import type { PolicyAction } from '../action.ts'
import { managerRolePolicyDefinition } from './managerRolePolicyDefinition.ts'

// 現場マネージャー：「組織設定、連携設定ができない組織管理者」のロール
// XXX: 各種ロールは定義の簡素化のため上位ロールを継承している。
//      権限を変更したら下位ロールにも影響する可能性があるため、継承関係を意識して変更すること
export const playingManagerRolePolicyDefinition: Record<PolicyAction, boolean> = {
  ...managerRolePolicyDefinition,
  'snapshot-object-read': false,
  'snapshot-object-schedule-manage': false,
  [`manage-policy`]: false,
  [`manage-organization-setting`]: false,
  [`manage-connection`]: false,
  // オブジェクト設定はデフォルトでは組織管理者のみ。一般ロールへは権限セットで個別に付与する (#9164)
  [`manage-elt-model`]: false,
  // レコード公開範囲 (OWD) の設定もデフォルトでは組織管理者のみ (E0 / #9659)
  [`manage-record-visibility`]: false,
  [`manage-group-assignment-history`]: false,
  [`manage-invitation`]: false,
}
